const FormContentWrapper = ({ classes, children }) => {
  return <div className={classes.content}>{children}</div>;
};

FormContentWrapper.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default withStyles(
  () => ({
    content: {
      background: '#fafbfc',
      flex: 1,
      padding: '25px 40px',
    },
  }),
  {
    name: 'FormContentWrapper',
  },
)(FormContentWrapper);
